import {ConnectBasicEntity} from '../../framework/message/ConnectBasicEntity';
import {ProcessStepChunkEvent} from './ProcessStepChunkEvent';
import {ProcessStepContextEngine} from './ProcessStepContextEngine';
import {ProcessStepPartitioner} from './ProcessStepPartitioner';
import {ProcessStepReader} from './ProcessStepReader';
import {ProcessStepTasklet} from './ProcessStepTasklet';
import {ProcessStepWriter} from './ProcessStepWriter';

export class ProcessStep extends ConnectBasicEntity {
chunkSize: number | null;
flowCode: string;
inType: string;
keepResultInJobContext: boolean | null;
keepResultInStepContext: boolean | null;
kind: string;
orderNumber: number | null;
outType: string;
partitioner: ProcessStepPartitioner;
processCode: string;
processMappingStepCode: string;
processor: string;
reader: ProcessStepReader;
stepChunkEvents: ProcessStepChunkEvent[];
stepContextEngines: ProcessStepContextEngine[];
stepName: string;
tasklet: ProcessStepTasklet;
visionCode: string;
writer: ProcessStepWriter;
}

